import React from 'react';
import { PublicContentPage } from './PublicContentPage';

export function WorkVideosPage() {
  return <PublicContentPage type="videos" title="কাজের ভিডিও" />;
}
